import { Component, OnInit, Input } from '@angular/core';
import { Search, ListItem, ParamsService, ListService, CrudService } from 'elbuild-ui-lib-core';
import { Provincia, Company, company, Tender, ProjectStatus } from 'toolbandi-ui-lib';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-project-list-filters',
	templateUrl: './project-list-filters.component.html',
	styleUrls: ['./project-list-filters.component.scss']
})
export class ProjectListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;
	active: boolean = true;

	company: {
		search: Search,
		selected: Company
	};

	tender: {
		search: Search,
		selected: Tender
	};

	stats = [...Object.keys(ProjectStatus)].map(v => ProjectStatus[v]);
	budget = { from: undefined, to: undefined, min: 0, max: 1000000 };

	@Input()
	companyid: number;
	@Input()
	tenderid: number;

	constructor(router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService) {
		super(router, _route, paramsService);

		this.initSearch();

	}

	ngOnInit() { }

	initSearch(): void {

		this.budget.from = undefined;
		this.budget.to = undefined;

		this.company = {
			search: new Search('company'),
			selected: undefined
		};

		this.tender = {
			search: new Search('tender'),
			selected: undefined
		};

	}

	readQueryParams(params: string) {
		super.readQueryParams(params);

	}

	resetSearch() {
		this.initSearch();
		this.keyword = undefined;
		this.active = true;
		super.resetSearch();
	}

	search(keeppage?: boolean) {
		this.setCompany();
		this.setTender();
		this.setStatus();
		this.setBudget();
		super.search(keeppage);

	}

	setCompany(): void {
		if (this.company.selected) {
			this.searchparams.addSimpleFilter('companyid', this.company.selected.id);
		}
	}

	setTender(): void {
		if (this.tender.selected) {
			this.searchparams.addSimpleFilter('tenderid', this.tender.selected.id);
		}
	}

	setStatus(): void {
		if (this.searchparams.simpleTmp['status'] === 'all') {
			this.searchparams.removeSimpleFilter('status');
		}
	}

	setBudget(): void {
		if ((this.budget.to || this.budget.to === 0) && !this.budget.from)
			this.budget.from = this.budget.min;
		if ((this.budget.from || this.budget.from === 0) && !this.budget.to)
			this.budget.to = this.budget.max;

		if (this.budget.from && this.budget.from < this.budget.min)
			this.budget.from = this.budget.min;
		if (this.budget.to && this.budget.to < this.budget.min)
			this.budget.to = this.budget.min;
		if (this.budget.from && this.budget.from > this.budget.max)
			this.budget.from = this.budget.max;
		if (this.budget.to && this.budget.to > this.budget.max)
			this.budget.to = this.budget.max;

		this.searchparams.rangeTmp['budget'] = { start: this.budget.from, stop: this.budget.to };
	}
}
